<template>
<form>
    <div class="row mt-3">
        <div class="col-lg-4">

            <h4 class="card-title">{{$t('small_technical_grants.general_info__project_title_card_title')}}</h4>
            <div class="form-group">
                <textarea
                    class="form-control"
                    name="technical.titleOfProject"
                    disabled="disabled"
                    v-model="GrantForm.title"
                    :error="getError('technical.titleOfProject')"
                    v-validate="'required'"
                    :data-vv-as="$t('medium_grant.technical__1_title_of_project')"
                    :label="$t('medium_grant.technical__1_title_of_project')"
                    :placeholder="$t('small_technical_grants.general_info__project_title_placeholder')">
                </textarea>
            </div>

            <h4 class="card-title">{{$t('small_technical_grants.general_info__lead_applicant_name_card_title')}}</h4>
            <div class="form-group">
                <textarea
                    class="form-control"
                    name="technical.leadApplicantName"
                    v-model="GrantForm.revisionModel.technical.leadApplicantName"
                    v-validate="'required'"
                    :disabled="!GrantForm.isRevisionEditable"
                    :error="getError('technical.leadApplicantName')"
                    :placeholder="$t('small_technical_grants.general_info__lead_applicant_name_placeholder')">
                </textarea>
            </div>

            <h4 class="card-title">{{$t('small_technical_grants.general_info__lead_applicant_organisation_card_title')}}</h4>
            <div class="form-group">
                <h6>
                    {{$t('small_technical_grants.general_info__lead_applicant_organisation_instructions')}}
                </h6>
                <div class="mt-4"></div>
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.organisationNational">
                    {{$t('rapid_response_grant.general_info__lead_applicant_organisation_checkbox_1')}}
                </base-checkbox>
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.organisationCountryBasedNonGuvernamental">
                    {{$t('rapid_response_grant.general_info__lead_applicant_organisation_checkbox_2')}}
                </base-checkbox>
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.organisationInternationalNonGuvernamental">
                    {{$t('rapid_response_grant.general_info__lead_applicant_organisation_checkbox_3')}}
                </base-checkbox>
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.organisationRegional">
                    {{$t('rapid_response_grant.general_info__lead_applicant_organisation_checkbox_4')}}
                </base-checkbox>
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.organisationCommunityBased">
                    {{$t('rapid_response_grant.general_info__lead_applicant_organisation_checkbox_5')}}
                </base-checkbox>
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.organisationProtectedAreas">
                    {{$t('rapid_response_grant.general_info__lead_applicant_organisation_checkbox_6')}}
                </base-checkbox>
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.organisationSMEs">
                    {{$t('rapid_response_grant.general_info__lead_applicant_organisation_checkbox_7')}}
                </base-checkbox>
            </div>
            <h6>{{$t('rapid_response_grant.general_info__lead_applicant_organisation_info')}}</h6>

            <h4 class="card-title">{{$t('small_technical_grants.general_info__co_applicant_name_card_title')}}</h4>
            <div class="form-group">
                <textarea class="form-control" name="technical.nameOfCoApplicants" v-model="GrantForm.revisionModel.technical.nameOfCoApplicants" :disabled="!GrantForm.isRevisionEditable" :error="getError('technical.nameOfCoApplicants')" v-validate="'required'"
                    :placeholder="$t('small_technical_grants.general_info__co_applicant_name_placeholder')">
          </textarea>
            </div>

            <h4 class="card-title">{{$t('small_technical_grants.general_info__co_applicant_organisation_card_title')}}</h4>
            <div class="form-group">
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.coApplicantOrganisationTypeGovernment">
                    {{$t('small_technical_grants.general_info__co_applicant_organisation_checkbox_1')}}
                </base-checkbox>
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.coApplicantOrganisationTypeProtected">
                    {{$t('small_technical_grants.general_info__co_applicant_organisation_checkbox_2')}}
                </base-checkbox>
            </div>

            <h4 class="card-title">{{$t('small_technical_grants.general_info__region_card_title')}}</h4>
            <div class="form-group">
                <label for="regionSelect">{{$t('medium_grant.technical__1_region')}}</label>
                <select class="form-control" @change="setRegion" name="technical.region" id="regionSelect" :error="getError('technical.region')" v-validate="'required'" :disabled="!GrantForm.isRevisionEditable" :data-vv-as="$t('medium_grant.technical__1_region')">
                    <option value="" selected="selected">{{$t('medium_grant.general__please_select')}}</option>
                    <option :value="region.regionId" :selected="GrantForm.regionId === region.regionId" v-for="region in regions" :key="region.regionId">{{region.code}} - {{region.name}}</option>
                </select>
                <label v-if="getError('technical.region')" class="error text-danger">{{getError('technical.region')}}</label>
            </div>

            <h4 class="card-title">{{$t('small_technical_grants.general_info__acp_country_card_title')}}</h4>
            <div class="form-group" :class="{'has-danger': getError('technical.acpCountry')}">
                <label for="countrySelect">{{$t('medium_grant.technical__1_acp_country')}}</label>
                <multiselect name="technical.acpCountry" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.acpCountry" selectLabel="" selectedLabel="" deselectLabel="Clear" v-validate="'required'" :data-vv-as="$t('medium_grant.technical__1_acp_country')"
                    :tag-placeholder="$t('medium_grant.general__please_select')" :placeholder="$t('medium_grant.general__please_select')" label="name" track-by="countryId" :options="countriesByRegion" :multiple="true"></multiselect>
                <label v-if="getError('technical.acpCountry')" class="error text-danger">{{getError('technical.acpCountry')}}</label>
            </div>
        </div>

        <div class="col-lg-4">
            <h4 class="card-title">{{$t('small_technical_grants.general_info__priority_area_targeted_card_title')}}</h4>
            <div class="form-group">
                <textarea class="form-control" name="technical.priorityAreaTargeted" v-model="GrantForm.revisionModel.technical.priorityAreaTargeted" :error="getError('technical.priorityAreaTargeted')" v-validate="'required'" :disabled="!GrantForm.isRevisionEditable"
                    :placeholder="$t('small_technical_grants.general_info__priority_area_targeted_placeholder')">
          </textarea>
            </div>

            <h4 class="card-title">{{$t('small_technical_grants.general_info__pa_registration_number_card_title')}}</h4>
            <h6>{{$t('small_technical_grants.general_info__pa_registration_number_instructions')}}</h6>
            <div class="form-group">
                <textarea class="form-control" name="technical.paRegistrationNumber" v-model="GrantForm.revisionModel.technical.paRegistrationNumber" :error="getError('technical.paRegistrationNumber')" v-validate="'required'" :disabled="!GrantForm.isRevisionEditable"
                    :placeholder="$t('small_technical_grants.general_info__pa_registration_number_placeholder')">
          </textarea>
            </div>

            <h4 class="card-title">{{$t('small_technical_grants.general_info__pa_supervisory_authority_card_title')}}</h4>
            <h6>{{$t('small_technical_grants.general_info__pa_supervisory_authority_instructions')}}</h6>
            <div class="form-group">
                <textarea class="form-control" name="technical.paSupervisoryAuthority" v-model="GrantForm.revisionModel.technical.paSupervisoryAuthority" :error="getError('technical.paSupervisoryAuthority')" v-validate="'required'" :disabled="!GrantForm.isRevisionEditable"
                    :placeholder="$t('small_technical_grants.general_info__pa_supervisory_authority_placeholder')">
          </textarea>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <base-input name="technical.startDate" v-model="GrantForm.revisionModel.technical.startDate" :error="getError('technical.startDate')" :disabled="!GrantForm.isRevisionEditable" v-validate="'required'" :data-vv-as="$t('medium_grant.technical__1_startdate')"
                        :placeholder="$t('medium_grant.technical__1_startdate')">
                        <label>{{$t('medium_grant.technical__1_startdate')}}</label>
                        <el-date-picker type="date" v-model="startDate" :disabled="!GrantForm.isRevisionEditable" :placeholder="$t('medium_grant.technical__1_startdate')">
                        </el-date-picker>
                    </base-input>
                </div>
                <div class="col-lg-6">
                    <base-input name="technical.endDate" v-model="GrantForm.revisionModel.technical.endDate" :placeholder="$t('medium_grant.technical__1_enddate')" :error="getError('technical.endDate')" :disabled="!GrantForm.isRevisionEditable" v-validate="'required'"
                        :data-vv-as="$t('medium_grant.technical__1_enddate')">
                        <label>{{$t('medium_grant.technical__1_enddate')}}</label>
                        <el-date-picker type="date" v-model="endDate" :disabled="!GrantForm.isRevisionEditable" :placeholder="$t('medium_grant.technical__1_enddate')">
                        </el-date-picker>
                    </base-input>
                </div>
            </div>

            <h4 class="card-title">{{$t('small_technical_grants.general_info__duration_card_title')}}</h4>
            <div class="form-group">
                <textarea class="form-control" name="technical.duration" v-model="GrantForm.revisionModel.technical.duration" :error="getError('technical.duration')" v-validate="'required'" :disabled="!GrantForm.isRevisionEditable" :data-vv-as="$t('medium_grant.technical__1_duration')"
                    :label="$t('medium_grant.technical__1_duration')" :placeholder="$t('medium_grant.technical__1_duration')">
          </textarea>
            </div>

            <h4 class="card-title">{{$t('small_technical_grants.general_info__total_annual_budget_card_title')}}</h4>
            <div class="form-group">
                <currency-input class="form-control" name="technical.totalPaAnualBudget" v-model="GrantForm.revisionModel.technical.totalPaAnualBudget" :error="getError('technical.totalPaAnualBudget')" currency="EUR" locale="de" v-validate="'required'"
                    :disabled="!GrantForm.isRevisionEditable" :placeholder="$t('small_technical_grants.general_info__total_annual_budget_placeholder')" />
            </div>

            <h4 class="card-title">{{$t('small_technical_grants.general_info__total_funding_requested_card_title')}}</h4>
            <div class="form-group">
                <currency-input class="form-control" name="technical.totalFundingRequested" v-model="GrantForm.revisionModel.technical.totalFundingRequested" :error="getError('technical.totalFundingRequested')" v-validate="'required'" currency="EUR"
                    :disabled="!GrantForm.isRevisionEditable" locale="de" :placeholder="$t('small_technical_grants.general_info__total_annual_budget_placeholder')" />
            </div>
        </div>

        <div class="col-lg-4">
            <h4 class="card-title">{{$t('small_technical_grants.general_info__action_component_objectives_card_title')}}</h4>
            <div class="form-group">
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.enhanceManagement">
                    {{$t('small_technical_grants.general_info__action_component_objectives_checkbox_1')}}
                </base-checkbox>
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.enforceLegalFramework">
                    {{$t('small_technical_grants.general_info__action_component_objectives_checkbox_2')}}
                </base-checkbox>
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.supportLocalCommunities">
                    {{$t('small_technical_grants.general_info__action_component_objectives_checkbox_3')}}
                </base-checkbox>
            </div>

            <h4 class="card-title">{{$t('rapid_response_grant.general_info__rpg_objectives_title')}}</h4>
            <div class="form-group">
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.rpgObjective1">
                    {{$t('rapid_response_grant.general_info__rpg_objectives_checkbox_1')}}
                </base-checkbox>
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.rpgObjective2">
                    {{$t('rapid_response_grant.general_info__rpg_objectives_checkbox_2')}}
                </base-checkbox>
                <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.rpgObjective3">
                    {{$t('rapid_response_grant.general_info__rpg_objectives_checkbox_3')}}
                </base-checkbox>
                <!-- <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.rpgObjective4">
            {{$t('rapid_response_grant.general_info__rpg_objectives_checkbox_4')}}
          </base-checkbox>
          <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.rpgObjective5">
            {{$t('rapid_response_grant.general_info__rpg_objectives_checkbox_5')}}
          </base-checkbox>
          <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.rpgObjective6">
            {{$t('rapid_response_grant.general_info__rpg_objectives_checkbox_6')}}
          </base-checkbox> -->
                <!-- <h6 class="mt-3" style="color: red">{{$t('small_technical_grants.general_info__diagnostic_tool_warn')}}</h6> -->
                <!-- <textarea
            class="form-control"
            name="technical.diagnosticToolReference"
            v-model="GrantForm.revisionModel.technical.diagnosticToolReference"
            :error="getError('technical.diagnosticToolReference')"
            v-validate="'required'"
            :placeholder="$t('small_technical_grants.general_info__diagnostic_tool_placeholder')"
          >
          </textarea> -->
            </div>

            <h4 class="card-title">{{$t('rapid_response_grant.general_info__priorities_for_action_card_title')}}</h4>
            <p>{{ $t('rapid_response_grant.general_words_remaining', {words: priorityWordsRemaining}) }}</p>
            <div class="form-group mt-3">
                <h6>{{$t('rapid_response_grant.general_info__priorities_for_action_card_question_title')}}</h6>
                <radio name="model.addressesRapidResponse" :disabled="!GrantForm.isRevisionEditable" value="yes" v-model="GrantForm.revisionModel.addressesRapidResponse">
                    {{$t('rapid_response_grant.general_info__priorities_for_action_card_question_yes')}}
                </radio>
                <radio name="model.addressesRapidResponse" :disabled="!GrantForm.isRevisionEditable" value="no" v-model="GrantForm.revisionModel.addressesRapidResponse">
                    {{$t('rapid_response_grant.general_info__priorities_for_action_card_question_no')}}
                </radio>
                <textarea class="form-control mt-3" name="technical.prioritiesForAction" v-model="GrantForm.revisionModel.technical.prioritiesForAction" @keyup="onPriorityKeyUp" :error="getError('technical.prioritiesForAction')" :disabled="!GrantForm.isRevisionEditable"
                    v-validate="'required'" rows="5" :placeholder="$t('small_technical_grants.general_info__priorities_for_action_placeholder')">
          </textarea>
            </div>

            <h4 class="card-title">{{$t('rapid_response_grant.general_info__summary_title')}}</h4>
            <p>{{ $t('rapid_response_grant.general_words_remaining', {words: summaryWordsRemaining}) }}</p>
            <div class="form-group">
                <!-- <h6>{{$t('small_technical_grants.general_info__priorities_for_action_instructions_1')}}</h6>
          <h6>{{$t('small_technical_grants.general_info__priorities_for_action_instructions_2')}}</h6> -->
                <textarea class="form-control" name="technical.summary" v-model="GrantForm.revisionModel.technical.summary" @keyup="onSummaryKeyUp" :error="getError('technical.summary')" :disabled="!GrantForm.isRevisionEditable" v-validate="'required'" rows="5"
                    :placeholder="$t('small_technical_grants.general_info__priorities_for_action_placeholder')">
          </textarea>
            </div>

            <h4 class="card-title">{{$t('rapid_response_grant.general_info__project_specific_keywords_title')}}</h4>
            <div class="form-group row">
                <div class="col-6">
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword1">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_1')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword2">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_2')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword3">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_3')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword4">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_4')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword5">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_5')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword6">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_6')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword7">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_7')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword8">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_8')}}
                    </base-checkbox>
                </div>
                <div class="col-6">
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword9">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_9')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword10">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_10')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword11">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_11')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword12">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_12')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword13">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_13')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword14">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_14')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword15">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_15')}}
                    </base-checkbox>
                    <base-checkbox name="checkbox" :disabled="!GrantForm.isRevisionEditable" v-model="GrantForm.revisionModel.technical.projectKeyword16">
                        {{$t('rapid_response_grant.general_info__project_specific_keywords_checkbox_16')}}
                    </base-checkbox>
                </div>
            </div>

        </div>
    </div>
</form>
</template>
<script>
import VueCurrencyInput from 'vue-currency-input';

import {
    DatePicker
} from 'element-ui';
import Multiselect from 'vue-multiselect';
import {
    GrantForm,
    RegionService
} from "@/services";
import {
    BaseAlert
} from 'src/components';

export default {
    components: {
        [DatePicker.name]: DatePicker,
        Multiselect,
        BaseAlert,
        VueCurrencyInput,
    },
    data() {
        return {
            GrantForm,
            startDate: '',
            endDate: '',
            moment: '',
            maxWordsPriority: 100,
            maxWordsSummary: 300,
            priorityWordsRemaining: 100,
            summaryWordsRemaining: 300,
            regions: [],
            options: [],
            value: [],
            downloadFiles: {
                en: '/files/en/Application_template_BIOPAMA_medium_grants_2019_EN.docx',
                fr: '/files/fr/Application_template_BIOPAMA_medium_grants_2019_FR.docx'
            }
        }
    },
    computed: {
        countriesByRegion() {
            let countries = [];
            let region = this.regions.filter((region) => {
                return region.regionId === GrantForm.regionId;
            })
            if (region[0] !== undefined && region[0].countries !== undefined && region[0].countries.length) {
                countries = region[0].countries;
            }
            return countries;
        }
    },
    async beforeMount() {
        this.moment = require('moment');

        let loader = this.$loading.show();
        let vm = this;
        RegionService.getApplicationRegionsWithCountries().then(function(response) {
            vm.regions = response.data;

            loader.hide();
        })

        if (GrantForm.revisionModel.technical.startDate !== undefined) {
            this.startDate = GrantForm.revisionModel.technical.startDate;
        }

        if (GrantForm.revisionModel.technical.endDate !== undefined) {
            this.endDate = GrantForm.revisionModel.technical.endDate;
        }
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate() {
            return this.$validator.validateAll().then(res => {
                this.$emit('on-validated', res, this.model);
                return res;
            });
        },
        setRegion(event) {
            GrantForm.regionId = parseInt(event.target.value);
            GrantForm.revisionModel.technical.acpCountry = [];
        },
        onPriorityKeyUp(ev) {
            let vm = this;
            let value = GrantForm.revisionModel.technical.prioritiesForAction || '';
            let words = value.split(/\s/);

            if (words.length >= vm.maxWordsPriority) {
                if (ev.keyCode != 46 && ev.keyCode != 8) {
                    ev.preventDefault();
                    value = words.slice(0, vm.maxWordsPriority).join(' ') + ' ';
                    GrantForm.revisionModel.technical.prioritiesForAction = value;
                }
            }

            vm.priorityWordsRemaining = Math.max(0, vm.maxWordsPriority - words.length);
        },
        onSummaryKeyUp(ev) {
            let vm = this;
            let value = GrantForm.revisionModel.technical.summary || '';
            let words = value.split(/\s/);

            if (words.length >= vm.maxWordsSummary) {
                if (ev.keyCode != 46 && ev.keyCode != 8) {
                    ev.preventDefault();
                    value = words.slice(0, vm.maxWordsSummary).join(' ') + ' ';
                    GrantForm.revisionModel.technical.summary = value;
                }
            }

            vm.summaryWordsRemaining = Math.max(0, vm.maxWordsSummary - words.length);
        },
    },
    watch: {
        startDate(newValue, oldValue) {
            GrantForm.revisionModel.technical.startDate = this.moment(newValue).format('YYYY-MM-DD');
        },
        endDate(newValue, oldValue) {
            GrantForm.revisionModel.technical.endDate = this.moment(newValue).format('YYYY-MM-DD');
        }
    }
}
</script>
<style lang="scss" scoped>
a {
    color: black;

    &:hover {
        text-decoration: underline;
    }
}

.el-date-picker .el-input textarea.el-input__inner,
.form-group textarea.el-input__inner,
textarea.form-control {
    border: 1px solid #2b3553;
    border-radius: 5px;
}
</style>
